module.exports = __webpack_public_path__ + "img/tree_circle.0dd5b626.svg";